/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsWebRuntimeTypeFromJSON, FxIdDomainSettingsWebRuntimeTypeToJSON, } from './FxIdDomainSettingsWebRuntimeType';
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions(value) {
    if (!('Default' in value) || value['Default'] === undefined)
        return false;
    if (!('Supported' in value) || value['Supported'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Default': FxIdDomainSettingsWebRuntimeTypeFromJSON(json['Default']),
        'Supported': (json['Supported'].map(FxIdDomainSettingsWebRuntimeTypeFromJSON)),
    };
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Default': FxIdDomainSettingsWebRuntimeTypeToJSON(value['Default']),
        'Supported': (value['Supported'].map(FxIdDomainSettingsWebRuntimeTypeToJSON)),
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions.js.map